import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IPromise, IQService, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {gettextCatalog} from "angular-gettext";
import {IntroJsTjeneste} from "felles/tjenester/IntroJs";
import {Kontekst} from "felles/tjenester/Kontekst";
import {Debugger} from "debug";
import {Autentisering} from "felles/tjenester/Autentisering";
import {TransitionService} from "@uirouter/angularjs";
import {WebNavigasjon} from "../../../../tjenester/WebNavigasjon";
import {Transition} from "@uirouter/core/lib/transition/transition";
import {DetteErNyttDialog} from "web/moduler/dashboard/modale/detteErNyttDialog/detteErNyttDialog";

require('./dashboard.scss');
const debug: Debugger = require('debug')('DashboardKontroller');

export class DashboardKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wdDashboard', {
                bindings: {aktivArkfane:'<'},
                controller: DashboardKontroller.forInjisering(),
                template: require('./dashboard.html')
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$q,
            regNavn.ng.ui.$transitions,
            Kontekst.regNavn,
            WebNavigasjon.regNavn,
            IntroJsTjeneste.regNavn,
            DetteErNyttDialog.regNavn,
            regNavn.gettext.gettextCatalog,
            DashboardKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $q: IQService,
                private $transitions: TransitionService,
                private kontekst: Kontekst,
                private webNavigasjon: WebNavigasjon,
                private introJs: IntroJsTjeneste,
                detteErNytt: DetteErNyttDialog,
                private gettextCatalog: gettextCatalog) {
            detteErNytt.visDialog();
    }

    /** forespurt initiell arkfane */
    aktivArkfane:DashboardArkfaner = DashboardArkfaner.plan ;//settes via bindings/$onChanges

    filter: l.DashboardFiltervalg;
    filterErEkspandert = false;

    private tilAvregistrering:Function[] = [];

    filtervalgOppdatert(filter: l.DashboardFiltervalg): IPromise<void> {
        this.filter = filter;
        return this.$q.resolve();
    }

    filterEkspandert(ekspandert: boolean) {
        this.filterErEkspandert = ekspandert;
    }

    navigerTilPlan() {
        this.persisterStandardArkfane(DashboardArkfaner.plan);
        this.webNavigasjon.gåTilPlan();
    }

    navigerTilMoeteliste() {
        this.persisterStandardArkfane(DashboardArkfaner.moeteliste);
        this.webNavigasjon.gåTilMøteliste();
    }

    navigerTilAarshjul() {
        this.persisterStandardArkfane(DashboardArkfaner.aarshjul);
        this.webNavigasjon.gåTilÅrshjul();
    }

    $onInit(): void {
        debug('$onInit', this.aktivArkfane);
        this.initAktivFane();
        this.lyttTilNavigasjon();
    }

    $onDestroy(): void {
        this.tilAvregistrering.forEach(avregistrering => avregistrering());
    }


    // hjelpemetoder

    private lyttTilNavigasjon(){
        this.tilAvregistrering.push(this.$transitions.onSuccess( {},(trans:Transition) => {
            debug("$transitions.onSuccess", trans, trans.paramsChanged(), trans.params())
            this.aktivArkfane = trans.params().aktivArkfane;
        }));
    }

    private initAktivFane() {
        //det er kun for innhold.dashboard (for denne state er aktivArkfane=null) at vi velger å vise den sist besøkte arkfanen
        if (this.aktivArkfane != null) return;

        this.gåTilStandardArkfane();
        //må lytte til brukerAutentisertEvent da kontekst kan være oppdatert fra serversiden
        this.$scope.$on(Autentisering.brukerAutentisertEvent, () => this.gåTilStandardArkfane());
    }

    private gåTilStandardArkfane(){
        switch (this.kontekst.brukervalg().dashboardfane){
            case DashboardArkfaner.plan: return this.navigerTilPlan();
            case DashboardArkfaner.moeteliste: return this.navigerTilMoeteliste();
            case DashboardArkfaner.aarshjul: return this.navigerTilAarshjul();
            default: return this.navigerTilPlan();
        }
    }

    private persisterStandardArkfane(fane: string) {
        this.kontekst.oppdaterBrukervalg({dashboardfane: fane});
    }
}

export enum DashboardArkfaner {
    plan = 'plan',
    moeteliste = 'moeteliste',
    aarshjul = 'aarshjul'
}
